<template>
  <div class="spribe-container">
    <div class="spribe-header">
      <h2 class="spribe-title">스프라이브 게임</h2>
      <div class="spribe-search">
        <input
          type="text"
          v-model="searchQuery"
          placeholder="게임 검색..."
          class="search-input"
        />
      </div>
    </div>

    <div class="games-grid">
      <div
        v-for="game in filteredGames"
        :key="game.game_id"
        class="game-card"
        @click="openGame(game)"
      >
        <div class="game-thumbnail">
          <img :src="game.game_icon_large" :alt="game.game_name" @error="handleImageError" />
          <div class="game-name-overlay">{{ game.game_name }}</div>
          <div class="game-overlay">
            <button class="play-btn">플레이</button>
          </div>
        </div>
        <div class="game-info">
          <h3 class="game-name">{{ game.game_name }}</h3>
          <span class="game-rtp" v-if="game.rtp !== '0.00'">RTP: {{ game.rtp }}</span>
        </div>
      </div>
    </div>

    <div v-if="filteredGames.length === 0" class="no-games">
      검색 결과가 없습니다.
    </div>
  </div>
</template>

<script>
export default {
  name: "KplaySpribe",
  data() {
    return {
      searchQuery: '',
      games: [
        { game_id: 1, game_name: "Aviator", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/1.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/1.png", rtp: "0.00" },
        { game_id: 2, game_name: "Dice", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/2.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/2.png", rtp: "0.00" },
        { game_id: 3, game_name: "Plinko", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/3.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/3.png", rtp: "0.00" },
        { game_id: 4, game_name: "Goal", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/4.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/4.png", rtp: "0.00" },
        { game_id: 5, game_name: "Hi Lo", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/5.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/5.png", rtp: "0.00" },
        { game_id: 6, game_name: "Mines", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/6.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/6.png", rtp: "0.00" },
        { game_id: 7, game_name: "Keno", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/7.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/7.png", rtp: "0.00" },
        { game_id: 8, game_name: "Mini Roulette", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/8.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/8.png", rtp: "0.00" },
        { game_id: 9, game_name: "Hotline", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/9.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/9.png", rtp: "0.00" },
        { game_id: 10, game_name: "Crystal Fall", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/10.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/10.png", rtp: "96.81%" },
        { game_id: 11, game_name: "Neo Vegas", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/11.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/11.png", rtp: "96.72%" },
        { game_id: 12, game_name: "Gates of Egypt", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/12.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/12.png", rtp: "96.91%" },
        { game_id: 13, game_name: "Forest of Whisps", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/13.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/13.png", rtp: "96.72%" },
        { game_id: 14, game_name: "Keplers Paradise", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/14.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/14.png", rtp: "97.15%" },
        { game_id: 15, game_name: "Viking Pub", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/15.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/15.png", rtp: "96.92%" },
        { game_id: 16, game_name: "Alien Farm", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/16.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/16.png", rtp: "97.16%" },
        { game_id: 17, game_name: "Balloon", game_icon: "https://slots.kplaycasino.com/spribe/minigames/id/17.png", game_icon_large: "https://slots.kplaycasino.com/500*500/spribe/minigames/id/17.png", rtp: "97%" },
      ]
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.page.isMobile;
    },
    filteredGames() {
      if (!this.searchQuery) return this.games;
      const query = this.searchQuery.toLowerCase();
      return this.games.filter(game =>
        game.game_name.toLowerCase().includes(query)
      );
    }
  },
  methods: {
    handleImageError(e) {
      e.target.src = 'https://picsum.photos/400/400';
    },
    async openGame(game) {
      if (!this.$store.state.user?.user) {
        return this.$store.dispatch('SHOW_ERR_MSG', '로그인이 필요합니다.');
      }

      try {
        const params = {
          domain_url: window.location.protocol + "//" + window.location.host + "/#/",
          product_id: 300,
          type: game.game_id,
          is_mobile: this.isMobile ? 1 : 0
        };

        const response = await this.$store.dispatch('GET_KPLAY_GAME', params);

        if (response.data && response.data.url) {
          window.open(
            response.data.url,
            'game_window',
            `width=${screen.width},height=${screen.height},left=0,top=0,scrollbars=yes,resizable=yes`
          );
        } else {
          this.$store.dispatch('SHOW_ERR_MSG', '게임을 불러올 수 없습니다.');
        }
      } catch (error) {
        console.error('Game launch error:', error);
        this.$store.dispatch('SHOW_ERR_MSG', '게임 실행 중 오류가 발생했습니다.');
      }
    }
  }
};
</script>

<style scoped>
.spribe-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
}

.spribe-header {
  margin-bottom: 30px;
}

.spribe-title {
  color: #D4AF37;
  font-size: 28px;
  margin-bottom: 20px;
  text-align: center;
}

.spribe-search {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.search-input {
  width: 100%;
  max-width: 400px;
  padding: 12px 20px;
  border: 1px solid #3a4040;
  border-radius: 25px;
  background: #2a3030;
  color: #fff;
  font-size: 14px;
}

.search-input:focus {
  outline: none;
  border-color: #D4AF37;
}

.games-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}

.game-card {
  background: #2a3030;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
}

.game-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(212, 175, 55, 0.2);
}

.game-thumbnail {
  position: relative;
  padding-top: 100%;
  overflow: hidden;
}

.game-thumbnail img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.game-name-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.game-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.game-card:hover .game-overlay {
  opacity: 1;
}

.play-btn {
  padding: 12px 30px;
  background: linear-gradient(135deg, #D4AF37, #F5D76E);
  border: none;
  border-radius: 25px;
  color: #000;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s;
}

.play-btn:hover {
  transform: scale(1.05);
}

.game-info {
  padding: 15px;
}

.game-name {
  color: #fff;
  font-size: 14px;
  margin: 0 0 5px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.game-rtp {
  color: #D4AF37;
  font-size: 12px;
}

.no-games {
  text-align: center;
  padding: 60px;
  color: #888;
  font-size: 18px;
}

@media (max-width: 768px) {
  .games-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .spribe-title {
    font-size: 22px;
  }
}
</style>
